const HIGHLIGHT_COLOR = '#232323'
const TEXT_COLOR = '#232323'

interface HeadingWithHighlightProps {
  before?: string
  highlight: string
  after?: string
  className?: string
}

export function HeadingWithHighlight({
  before = '',
  highlight,
  after = '',
  className = '',
}: HeadingWithHighlightProps) {
  return (
    <h1
      className={`text-[22px] font-[400] leading-[130%] text-left pt-4 ${className}`}
      style={{ color: TEXT_COLOR }}
    >
      {before && <span>{before}</span>}
      <span style={{ color: HIGHLIGHT_COLOR, fontWeight: '700' }}>{highlight}</span>
      {after && <span>{after}</span>}
    </h1>
  )
}
